import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  Card,
  Page,
  Radio,
  RadioGroup,
  Text,
} from '../../components';
import { updateLanguage } from '../../modules/supportedLanguage';
import { getSelectedLanguage } from '../../modules/selectors';

const propTypes = {
  selectedLanguage: PropTypes.shape({
    languageId: PropTypes.number,
  }).isRequired,
  dispatch: PropTypes.func.isRequired,
};

class SupportedLanguage extends Component {
  handleClick = (value) => {
    const { dispatch } = this.props;
    dispatch(updateLanguage(value));
  }

  render() {
    const { selectedLanguage: { languageId } } = this.props;

    const languageOptions = [
      { description: 'English', value: 1 },
      { description: 'Spanish', value: 2 },
      { description: 'Australian', value: 3 },
      { description: 'Vietnamese', value: 4 },
      { description: 'Polish', value: 5 },
      { description: 'Russian', value: 6 },
      { description: 'Korean', value: 7 },
    ];
    const renderLanguages = languageOptions.map(languageOption => (
      <Radio
        key={languageOption.description}
        name={languageOption.description}
        value={languageOption.value.toString()}
        label={languageOption.description}
        onChange={() => this.handleClick(languageOption.value)}
      />
    ));
    return (
      <Page>
        <Card>
          <Card.Block>
            <Text as="h1">Supported Language</Text>
            <RadioGroup name="suggestedLanguages" defaultChecked={languageId ? languageId.toString() : '1'}>
              {renderLanguages}
            </RadioGroup>
          </Card.Block>
        </Card>
      </Page>
    );
  }
}

function mapStateToProps(state) {
  return {
    selectedLanguage: getSelectedLanguage(state),
  };
}
SupportedLanguage.propTypes = propTypes;
export default connect(mapStateToProps)(SupportedLanguage);
